import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import IssuesHeader from './IssuesHeader';
import IssuesTable from './IssuesTableView';
import IssuesCard from './IssuesCardView';
import { useIssuesCache } from '../../contexts/IssuesCacheContext';
import issueService from '../../services/issueService';
import { IssueItem } from '@/models/issueItem';

const IssueList: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filter, setFilter] = useState<string>('');
  const [view, setView] = useState<'table' | 'card'>('table');

  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [issues, setIssues] = useState<IssueItem[]>([]);
  const { issues, setIssues } = useIssuesCache(); // Use the hook

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  const handleFilter = (filter: string) => {
    setFilter(filter);
  };

  const handleViewChange = (newView: 'table' | 'card') => {
    setView(newView);
  };

  const filteredIssues = React.useMemo(() => {

    const isMatching = (( issue: IssueItem) => {
      const searchMatch =
        issue.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.stacktrace?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.possible_solution?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        issue.id.toString().includes(searchTerm.toLowerCase());
  
      const filterMatch = filter === '' || issue.status === filter;
  
      return searchMatch && filterMatch;
    });
  
    try {
      return (!issues || issues.length === 0) 
        ? []
        : issues.filter((issue) => isMatching(issue));

    } catch ( err) {

      console.log( "Failed to match filer criteria in IssueList", err);
      setError('Failed to match with filter criteria in IssueList');
      return [];
    }
  }, [issues, searchTerm, filter]);

  useEffect(() => {
    const fetchIssues = async () => {
      setIsLoading(true);
      setError(null);
      try {
        console.log( `Issues is not laoded. Load the sample issues.`)
        const data = await issueService.getIssues();
        setIssues(data);
      } catch (err) {
        setError('Failed to load issues.');
      } finally {
        setIsLoading(false);
      }
    };

    if (!issues) {
      fetchIssues();
    } else {
      setIsLoading(false);
    }
  }, [issues, setIssues]);

  if (isLoading) {
    return <div>Loading issues...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h1>Issues for Team: {teamId}</h1>
      <div className="issues-container">
        <div className="issues-header-container"> 
          <IssuesHeader
            onSearch={handleSearch}
            onFilter={handleFilter}
            onViewChange={handleViewChange}
            currentView={view}
          />
        </div>
        {view === 'table' ? (
          <IssuesTable issues={filteredIssues} />
        ) : (
          <IssuesCard issues={filteredIssues} />
        )}
      </div>
    </div>
  );
};

export default IssueList;
